export default __webpack_public_path__ + "static/media/sprites.4d8a01ab.svg";